import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationCode',
  props: {
    errorMessage: null,
    codeLength: { default: 6 }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: "input", value?: string): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { errorMessage?: string, codeLength: number };

  
  const code = ref<string[]>(Array(props.codeLength));

  let dataFromPaste: string[] | undefined;

  


  function handleInput(event: Event) {
    const inputType = (event as InputEvent).inputType;
    let currentActiveElement = event.target as HTMLInputElement;

    if (inputType === "insertText" && (currentActiveElement.nextElementSibling as HTMLElement)){
      (currentActiveElement.nextElementSibling as HTMLElement).focus();
    }

    if (inputType === "insertFromPaste" && dataFromPaste) {
      for (const num of dataFromPaste) {
        const id: number = parseInt(currentActiveElement.id.split("_")[1]);
        currentActiveElement.value = num;
        code.value[id] = num;
        if (currentActiveElement.nextElementSibling) {
          currentActiveElement = currentActiveElement.nextElementSibling as HTMLInputElement;
          if(currentActiveElement.nextElementSibling) {
            (currentActiveElement.nextElementSibling as HTMLElement).focus();
          }
        }
      }
    }

    emit("input", code.value.join(""));
  }

  function handleDelete(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const currentActiveElement = event.target as HTMLInputElement;
    if (!value && currentActiveElement.previousElementSibling) { 
      (currentActiveElement.previousElementSibling as HTMLElement).focus();
    }
  }

  function onPaste(event: Event) {
    if( !( event instanceof ClipboardEvent) || !event.clipboardData) return;

    dataFromPaste = event.clipboardData.getData("text").trim().split("");
    if(!dataFromPaste) return;
    for (const text of dataFromPaste) {
      if (!text) event.preventDefault();
    }
  }

return { __sfc: true,props, code, dataFromPaste, emit, handleInput, handleDelete, onPaste }
}

})